export interface ConfirmDateConfig {
  confirmIcon: string;
  confirmText: string;
}

export const ConfirmDatePlugin = (pluginConfig: Partial<ConfirmDateConfig>) => {
  const defaultConfig = {
    confirmIcon: `
      <svg version='1.1' xmlns='http://www.w3.org/2000/svg'
            xmlns:xlink='http://www.w3.org/1999/xlink' width='17' height='17' viewBox='0 0 17 17'>
        <g></g>
        <path d='M15.418 1.774l-8.833 13.485-4.918-4.386 0.666-0.746 4.051 3.614 8.198-12.515 0.836 0.548z' fill='#000000' />
      </svg>
    `,
    confirmText: 'OK '
  };

  const config = { ...defaultConfig, ...pluginConfig };

  return (fp: any) => {
    const hooks = {
      onKeyDown (_: any, __: any, ___: any, e: KeyboardEvent) {
        if (fp.config.enableTime && e.key === 'Tab' && e.target === fp.amPM) {
          e.preventDefault();
          fp.confirmContainer.focus();
        } else if (e.key === 'Enter' && e.target === fp.confirmContainer) {
          fp.close();
        }
      },

      onReady () {
        if (fp.calendarContainer === undefined) {
          return;
        }

        fp.confirmContainer = fp._createElement(
          'div',
          `flatpickr-confirm visible lightTheme`,
          config.confirmText
        );

        fp.confirmContainer.tabIndex = -1;
        fp.confirmContainer.innerHTML += config.confirmIcon;

        fp.confirmContainer.addEventListener('click', (event: Event) => {
          event.stopPropagation();
          fp.close();
        });
        fp.calendarContainer.appendChild(fp.confirmContainer);
      }
    };

    return hooks;
  }
}
